import { useCallback } from 'react';
import { tasksApi } from './api';
import { TaskFormValues } from './task-form';
import { FormikHelpers } from 'formik';
import { TaskDto } from '@sr/dto';

export const useEditTaskForm = (task: TaskDto, onSuccess: () => void) => {
  const [updateTask, { isLoading }] = tasksApi.useUpdateTaskMutation();

  const initialValues: TaskFormValues = {
    theme: task.theme,
    description: task.description ?? '',
    managerId: task.manager?.id ?? null,
    employeeIds: task.employees?.map(e => e.id) ?? [],
    dueDate: task.dueDate ? new Date(task.dueDate) : null,
    status: task.status,
  };

  const handleSubmit = useCallback(
    async (values: TaskFormValues, formikHelpers: FormikHelpers<TaskFormValues>) => {
      const dueDateValue = values.dueDate ? new Date(values.dueDate) : undefined;
      try {
        await updateTask({
          id: task.id,
          theme: values.theme,
          description: values.description,
          managerId: values.managerId ?? undefined,
          employeeIds: values.employeeIds,
          dueDate: dueDateValue,
          status: values.status,
        }).unwrap();
        onSuccess();
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [task.id, updateTask, onSuccess],
  );

  return { initialValues, handleSubmit, isLoading };
};
